import React from 'react';
import { createRoot } from 'react-dom/client'; // ✅ correct import
import App from './App';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import store from './utils/Redux/Store/Store';

const queryClient = new QueryClient();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
);

// ReactDOM.render(
//   <QueryClientProvider client={queryClient}>
//     <Provider store={store}>
//       <App />
//     </Provider>
//     <ReactQueryDevtools />
//   </QueryClientProvider>
//   , document.getElementById('root')
// )

